import React from 'react';
import PropTypes from 'prop-types';

const SummarySectionTitle = ({ title }) => (
  <>
    <div className="summary-section-title">{title}</div>
    <div className="divider" />
  </>
);

SummarySectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SummarySectionTitle;
